import { I18nValue } from "@/components/i18n/lang-context"

export const ARTICLE_TYPES = ['press', 'web', 'twitter', 'linkedin', 'partnership', 'video'] as const
export type ArticleType = typeof ARTICLE_TYPES[number]

export type Article = {
  titre: I18nValue
  source: string | {media: string, logo_url: string}
  url: I18nValue
  date: string
  type: ArticleType
  citation: I18nValue
}

export const PRESS_ARTICLES: Article[] = [
  {
    titre: {
      fr: 'Une nouvelle ère pour l’immobilier de luxe sur la Côte d’Azur',
      en: 'A New Era for Luxury Real Estate on the French Riviera'
    },
    source: 'carlton',
    url: {
      fr: 'https://www.carlton-international.com/carlton-international-sassocie-avec-legibloq-une-nouvelle-ere-pour-limmobilier-de-luxe-sur-la-cote-dazur/',
      en: 'https://www.carlton-international.com/en/carlton-international-partners-with-legibloq-a-new-era-for-luxury-real-estate-on-the-french-riviera/'
    },
    date: '2026-03-18',
    type: 'partnership',
    citation: {
      fr: 'En s’associant avec Legibloq, Carlton International ouvre la voie à une nouvelle génération de transactions immobilières sur la Côte d’Azur. L’immobilier de luxe entre dans une nouvelle dimension, plus fluide, plus internationale, plus innovante.',
      en: 'By partnering with Legibloq, Carlton International is paving the way for a new generation of real estate transactions on the French Riviera. Luxury real estate is entering a new dimension—more seamless, more international, and more innovative.'
    },
  },
  {
    titre: {
      fr: 'Côte d’Azur Sotheby’s International Realty innove avec Legibloq',
      en: 'Côte d’Azur Sotheby’s International Realty innovates with Legibloq'
    },
    source: 'sothebyscotedazur',
    url: {
      fr: 'https://www.cotedazur-sothebysrealty.com/fr/partenariats/details/1354/immobilier-luxe-cryptomonnaie',
      en: 'https://www.cotedazur-sothebysrealty.com/en/partnership/details/1354/luxury-real-estate-cryptocurrency'
    },
    date: '2025-09-30',
    type: 'partnership',
    citation: {
      fr: 'Avec cette innovation, les transactions en cryptomonnaie deviennent accessibles, rapides et fiables, tout en restant conformes à la réglementation. Côte d’Azur Sotheby’s International Realty et Legibloq ouvrent une nouvelle ère pour l’acquisition de biens d’exception.',
      en: 'With this innovation, cryptocurrency transactions become accessible, fast, and reliable, while remaining fully compliant with regulations. Côte d’Azur Sotheby’s International Realty and Legibloq are ushering in a new era for acquiring exceptional properties.'
    },
  },
  {
    titre: {
      fr: 'Payer en cryptomonnaie c’est désormais possible chez Impact',
      en: 'Paying in cryptocurrency is now possible at Impact'
    },
    source: 'impact',
    url: {
      fr: 'https://cannes-impact.com/fr/actualites/agence-impact-accepte-paiement-cryptomonnaie',
      en: 'https://cannes-impact.com/en/news/paying-in-cryptocurrency-possible-impact-cannes'
    },
    date: '2026-02-10',
    type: 'partnership',
    citation: {
      fr: 'En acceptant le paiement en cryptomonnaie, Impact affirme sa volonté d’innover (...) Notre objectif reste le même : vous accompagner avec sérieux, transparence et efficacité, tout en vous offrant des solutions à la hauteur de vos ambitions.',
      en: ''
    },
  },
  {
    titre: {
      fr: 'Les atouts de la cryptomonnaie dans l’immobilier de luxe',
      en: 'The benefits of cryptocurrency in real estate'
    },
    source: 'magrey',
    url: {
      fr: 'https://www.magrey.fr/journal/cryptomonnaie-immobilier-de-prestige',
      en: 'https://www.magrey.com/journal/cryptocurrency--and-real-estate'
    },
    date: '2025-07-23',
    type: 'partnership',
    citation: {
      fr: 'Conscients de l’importance d’accompagner cette mutation avec sérieux, nous avons choisi de nous associer à Legibloq. Avec Legibloq, nos clients bénéficient d’une expérience fluide et fiable, où innovation technologique et rigueur juridique se conjuguent.',
      en: 'To ensure this transition is handled with absolute reliability, Magrey & Sons has partnered with Legibloq. With Legibloq, our clients enjoy a seamless, secure experience where cutting-edge technology meets a robust legal framework.'
    },
  },
  {
    titre: {
      fr: 'Citylife Arcachon innove avec le paiement en cryptomonnaies'
    },
    source: 'citylifearcachon',
    url: {
      fr: 'https://arcachon.citylife.fr/fr/blog/notre-agence-accepte-desormais-les-cryptomonnaies-une-premiere-sur-le-bassin-d-arcachon'
    },
    date: '2026-01-19',
    type: 'partnership',
    citation: {
      fr: 'Le marché immobilier du Bassin d’Arcachon franchit une nouvelle étape. Citylife Arcachon annonce le lancement d’un nouveau service (...) en partenariat avec Legibloq'
    },
  },
  {
    titre: {
      fr: 'L’immobilier et les crypto-actifs : une nouvelle ère commence',
      en: 'Real estate and crypto-assets: a new era begins'
    },
    source: 'victoireproprietes',
    url: {
      fr: 'https://www.victoireproprietes.com/fr/blog/immobiliare-e-criptoattive-inizia-una-nuova-era,146',
      en: 'https://www.victoireproprietes.com/en/blog/immobiliare-e-criptoattive-inizia-una-nuova-era,146'
    },
    date: '2025-11-18',
    type: 'partnership',
    citation: {
      fr: 'Grâce à Legibloq, Victoire Propriétés élargit son offre et accompagne désormais ses clients dans des transactions immobilières utilisant les crypto-actifs, avec un niveau de sécurité et de conformité inégalé',
      en: 'Thanks to Legibloq, Victoire Propriétés is expanding its offer and now supports its clients in real estate transactions using crypto-assets, with an unparalleled level of security and compliance'
    },
  },
  {
    titre: {
      fr: 'La Cryptomonnaie et Le Marché Immobilier'
    },
    source: 'lacremerie',
    url: {
      fr: 'https://lacremerie-immobilier.fr/la-cryptomonnaie-et-limmobilier'
    },
    date: '2025-09-22',
    type: 'partnership',
    citation: {
      fr: 'Nous avons choisi de collaborer avec Legibloq, une entreprise pionnière dans la sécurisation juridique et technologique des transactions en actifs numériques, appliqués au secteur de l’immobilier'
    },
  },
  {
    titre: {
      en: '🏡 Carlton International x Legibloq: a new milestone for luxury real estate on the French Riviera'
    },
    source: 'carlton',
    url: {
      en: 'https://www.linkedin.com/pulse/carlton-international-x-legibloq-new-milestone-luxury-ohbee/'
    },
    date: '2026-03-19',
    type: 'linkedin',
    citation: {
      en: 'From Cannes to Saint-Jean-Cap-Ferrat, the Riviera continues to attract investors seeking stability, prestige, and a secure store of value. This partnership reflects a deeper trend: the convergence of digital finance and high-end real estate.'
    },
  },
  {
    titre: {
      fr: 'Acheter une propriété de luxe avec des cryptomonnaies ? C’est désormais possible avec Magrey & Sons, grâce à Legibloq',
      en: 'Buying a luxury property with cryptocurrency ? It’s now possible with Magrey & Sons, thanks to Legibloq'
    },
    source: 'magrey',
    url: {
      fr: 'https://www.linkedin.com/feed/update/urn:li:activity:7361645284835188736',
      en: 'https://www.linkedin.com/feed/update/urn:li:activity:7361645284835188736'
    },
    date: '2025-08-14',
    type: 'video',
    citation: {
      fr: '/partners/magrey-and-sons/magrey-and-sons-video.png',
      en: '/partners/magrey-and-sons/magrey-and-sons-video.png'
    },
  },
  {
    titre: {
      fr: 'Avec Legibloq, nous innovons pour faciliter vos projets immobiliers'
    },
    source: 'lecastel',
    url: {
      fr: 'https://www.linkedin.com/feed/update/urn:li:activity:7374754933897719808'
    },
    date: '2025-10-02',
    type: 'video',
    citation: {
      fr: '/partners/le-castel/le-castel-video.png'
    },
  },
  {
    titre: {
      fr: '🔹Une première en France 💪🔹Legibloq',
      en: '🔹A First in France 💪🔹Legibloq'
    },
    source: {
      media: 'LinkedIn – Thomas Putine',
      logo_url: '/press/logo-linkedin.png'
    },
    url: {
      fr: 'https://fr.linkedin.com/posts/thomas-putine-50210179_notariat-cryptomonnaie-innovationjuridique-activity-7338264032459612161-9Sba',
      en: 'https://fr.linkedin.com/posts/thomas-putine-50210179_notariat-cryptomonnaie-innovationjuridique-activity-7338264032459612161-9Sba'
    },
    date: '2025-06-10',
    type: 'linkedin',
    citation: {
      fr: 'J’ai eu l’honneur et le plaisir de réaliser la toute première vente immobilière en cryptomonnaie sur le territoire français via la solution pensée et créée par Legibloq',
      en: 'I had the honor and pleasure of completing the very first real estate sale in France as a notary using crypto via the innovative solution designed and developed by Legibloq'
    }
  },
  {
    titre: {
      fr: 'Acheter un bien immobilier avec des cryptomonnaies : c’est non seulement possible, mais sécurisé !'
    },
    source: {
      media: 'Journal de l’Agence',
      logo_url: 'https://img.logo.dev/journaldelagence.com?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.journaldelagence.com/1408911-acheter-un-bien-immobilier-avec-des-cryptomonnaies-cest-non-seulement-possible-mais-securise'
    },
    date: '2025-12-18',
    type: 'web',
    citation: {
      fr: 'Son leitmotiv ? Démocratiser et sécuriser l’achat immobilier en cryptos en accompagnant au mieux les professionnels du secteur. Rencontre avec son cofondateur, Emeric Fillatre.'
    }
  },
  {
    titre: {
      fr: 'Il achète une maison à 370.000 euros à Lyon avec ses cryptomonnaies, une première en France'
    },
    source: {
      media: 'BFM TV',
      logo_url: 'https://img.logo.dev/bfmtv.com?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.bfmtv.com/crypto/il-achete-une-maison-a-370-000-euros-a-lyon-avec-ses-cryptomonnaies-une-premiere-en-france_AN-202506180502.html'
    },
    date: '2025-06-18',
    type: 'web',
    citation: {
      fr: 'Après vérification de l’origine des fonds, ’ces derniers ont été entièrement bloqués sur une adresse blockchain dédiée à l’opération, en amont du compromis et convertis en euros, puis transférés au notaire sur son compte CDC suite à son appel de fonds’, explique Legibloq à BFM Crypto.'
    }
  },
  {
    titre: {
      fr: 'Il achète une maison en cryptos, le vendeur reçoit des euros : une première en France'
    },
    source: {
      media: 'Capital',
      logo_url: 'https://img.logo.dev/capital.fr?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.capital.fr/immobilier/il-achete-une-maison-en-cryptos-le-vendeur-recoit-des-euros-une-premiere-en-france-1514591'
    },
    date: '2025-06-04',
    type: 'web',
    citation: {
      fr: 'Pour la première fois en France, une transaction immobilière aura lieu en utilisant une blockchain. Cette technique offre d’importantes ...'
    }
  },
  {
    titre: {
      fr: 'Rhône - Un Lyonnais paye sa maison grâce aux cryptomonnaies'
    },
    source: {
      media: 'Le Dauphiné Libéré',
      logo_url: 'https://img.logo.dev/ledauphine.com?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.ledauphine.com/economie/2025/06/22/une-premiere-en-france-un-lyonnais-achete-sa-maison-en-cryptomonnaie'
    },
    date: '2025-06-22',
    type: 'web',
    citation: {
      fr: 'Notre solution permet à tout acquéreur disposant de cryptoactifs de les utiliser directement pour acheter un bien immobilier, sans passer par une banque ni impacter le vendeur, en respectant les obligations liées à la lutte contre le blanchiment et le financement du terrorisme. L’acquéreur, détenteur de cryptoactifs, transfère ses fonds directement dans un séquestre sécurisé, sans avoir à les convertir au préalable en euros, le notaire reçoit le jour de la signature le montant en euros.'
    }
  },
  {
    titre: {
      fr: 'Une première en France : il achète sa maison en cryptomonnaie, le vendeur recevra 370 000 euros'
    },
    source: {
      media: 'La Voix du Nord',
      logo_url: 'https://img.logo.dev/lavoixdunord.fr?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.lavoixdunord.fr/1597285/article/2025-06-18/une-premiere-en-france-il-achete-sa-maison-en-cryptomonnaie-le-vendeur-recevra'
    },
    date: '2025-06-18',
    type: 'web',
    citation: {
      fr: 'Notre ambition est de libérer les montants aujourd’hui bloqués en cryptomonnaie et de les injecter en toute conformité dans l’économie traditionnelle. Cette première transaction prouve que c’est possible dès aujourd’hui », a expliqué Emeric Fillatre, cofondateur de JBDA.'
    }
  },
  {
    titre: {
      fr: 'Acheter une maison en cryptomonnaie mais payer le vendeur en euros ? C’est possible, voici comment'
    },
    source: {
      media: 'Boursorama',
      logo_url: 'https://img.logo.dev/boursorama.com?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.boursorama.com/patrimoine/actualites/acheter-une-maison-en-cryptomonnaie-mais-payer-le-vendeur-en-euros-c-est-possible-voici-comment-0001f3c9c384d139e6e0600eca2597a6'
    },
    date: '2025-06-05',
    type: 'web',
    citation: {
      fr: 'JBDA a vérifié l’origine des fonds numériques avant de les placer sur un compte séquestre via sa solution baptisée Legibloq.'
    }
  },
  {
    titre: {
      fr: 'Rhône Une première en France : un Lyonnais vient d’acheter sa maison intégralement grâce à la cryptomonnaie'
    },
    source: {
      media: 'Le Progrès',
      logo_url: 'https://img.logo.dev/leprogres.fr?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.leprogres.fr/economie/2025/06/21/une-premiere-en-france-un-lyonnais-vient-d-acheter-sa-maison-integralement-en-cryptomonnaie'
    },
    date: '2025-06-21',
    type: 'web',
    citation: {
      fr: 'L’acquéreur, détenteur de cryptoactifs, transfère ses fonds directement dans un séquestre sécurisé, sans avoir à les convertir au préalable en euros, le notaire reçoit le jour de la signature le montant en euros.»'
    }
  },
  {
    titre: {
      fr: 'Lyon : une maison achetée avec de la cryptomonnaie pour la première fois en France'
    },
    source: {
      media: 'Lyon Mag',
      logo_url: 'https://img.logo.dev/lyonmag.com?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.lyonmag.com/article/144897/lyon-une-maison-achetee-avec-de-la-cryptomonnaie-pour-la-premiere-fois-en-france'
    },
    date: '2025-06-23',
    type: 'web',
    citation: {
      fr: 'Et cela, grâce à la startup française Legibloq, qui a permis de convertir la crypto en euros.'
    }
  },
  {
    titre: {
      fr: 'Pour la première fois en France, une maison achetée 370 000 euros à Lyon...en cryptomonnaies'
    },
    source: {
      media: 'Le Bonbon',
      logo_url: 'https://img.logo.dev/lebonbon.fr?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.lebonbon.fr/lyon/societe/premiere-france-maison-achetee-cryptomonnaies-lyon'
    },
    date: '2025-06-20',
    type: 'web',
    citation: {
      fr: 'Tout ça, orchestré dans les règles de l’art grâce à la plateforme Legibloq, développée par la startup tricolore JBDA.'
    }
  },
  {
    titre: {
      fr: 'Crypto et achat immobilier : une maison à 370 000 € à Lyon payée en stablecoins USDC'
    },
    source: {
      media: 'Journal du Coin',
      logo_url: 'https://img.logo.dev/journalducoin.com?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://journalducoin.com/actualites/crypto-achat-immobilier-maison-370000-euros-payee-stablecoins-usdc-lyon'
    },
    date: '2025-06-19',
    type: 'web',
    citation: {
      fr: 'Grâce à un système de séquestre sécurisé, l’acquéreur achète une maison près de Lyon pour 370 000 € sans convertir à l’avance ses cryptos en euros. Le notaire, lui, reçoit la somme en euros le lendemain de l’appel de fonds.'
    }
  },
  {
    titre: {
      fr: 'Sophia : JBDA annonce la première transaction immobilière en cryptomonnaie'
    },
    source: {
      media: 'Sophianet',
      logo_url: 'https://img.logo.dev/sophianet.com?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.sophianet.com/article/sophia-jbda-annonce-premiere-transaction-immobiliere-cryptomonnaie'
    },
    date: '2025-06-04',
    type: 'web',
    citation: {
      fr: 'Créée par Jarvix, un spécialiste blockchain, et un cabinet d’avocats d’affaires, la startup a développé la solution Legibloq® pour permettre une transaction immobilière fluide et sécurisée sans avoir converti les cryptos en euros.'
    }
  },
  {
    titre: {
      fr: 'France enregistre premier achat immobilier crypto'
    },
    source: {
      media: 'BeInCrypto (FR)',
      logo_url: 'https://img.logo.dev/beincrypto.com?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://fr.beincrypto.com/marches/554982/france-enregistre-premier-achat-immobilier-crypto'
    },
    date: '2025-06-05',
    type: 'web',
    citation: {
      fr: 'L’acheteur a dû s’aider de la solution Legibloq développée par JBDA, une start-up basée dans les Alpes-Maritimes, qui a permis de sécuriser la transaction et vérifier l’origine des stablecoins.'
    }
  },
  {
    titre: {
      fr: 'Un acheteur acquiert une maison en cryptomonnaies, tandis que le vendeur opte pour des euros : une première en France'
    },
    source: {
      media: 'Mediavor',
      logo_url: 'https://img.logo.dev/mediavor.fr?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.mediavor.fr/achat-maison-cryptomonnaies-france/#Immobilier_et_cryptomonnaies_une_premiere_transaction_en_France_avec_paiement_en_euros_pour_le_vendeur'
    },
    date: '2025-06-19',
    type: 'web',
    citation: {
      fr: 'L’acheteur, salarié de 35 ans, a ainsi pu acquérir sa résidence principale pour 370 sans que le vendeur ne soit exposé aux risques de volatilité. Le paiement effectué en stablecoins a été converti en euros via Legibloq, solution fruit d’une collaboration entre une spécialisée en blockchain et un cabinet d’avocats.'
    }
  },
  {
    titre: {
      fr: 'Comment révolutionner la transaction immobilière avec la crypto ?'
    },
    source: {
      media: 'Monimmeuble.com',
      logo_url: 'https://img.logo.dev/monimmeuble.com?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://monimmeuble.com/actualite/comment-revolutionner-la-transaction-immobiliere-avec-la-crypto'
    },
    date: '2025-06-19',
    type: 'web',
    citation: {
      fr: 'L’offre de Legibloq® est la solution la plus simple et transparente pour permettre d’acheter des biens immobiliers avec des cryptomonnaies.'
    }
  },
  {
    titre: {
      fr: 'Immobilier et crypto : une première transaction légale réussie en France avec Legibloq'
    },
    source: {
      media: 'Club Patrimoine',
      logo_url: 'https://img.logo.dev/clubpatrimoine.com?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.clubpatrimoine.com/contenus/immobilier-cryptomonnaie-premiere-transaction'
    },
    date: '2025-06-05',
    type: 'web',
    citation: {
      fr: 'Legibloq®, lancée fin 2024, repose sur un mécanisme de séquestre de cryptomonnaies conçu pour garantir la sécurité juridique et financière des parties.'
    }
  },
  {
    titre: {
      fr: 'Crypto et immobilier de luxe : une alliance stratégique en plein essor'
    },
    source: {
      media: 'Club Patrimoine',
      logo_url: 'https://img.logo.dev/clubpatrimoine.com?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.clubpatrimoine.com/contenus/immobilier-luxe-crypto'
    },
    date: '2025-07-23',
    type: 'web',
    citation: {
      fr: 'En France, même si les notaires ne peuvent pas recevoir directement des cryptomonnaies sur leurs comptes à la Caisse des Dépôts, des solutions comme Legibloq® permettent une conversion sécurisée via un séquestre notarial, garantissant la conformité réglementaire et la traçabilité des fonds.'
    }
  },
  {
    titre: {
      fr: 'Achat immobilier en cryptomonnaie : une première en France où le vendeur encaisse en euros'
    },
    source: {
      media: 'oboncoin.fr',
      logo_url: '/press/logo-oboncoin.png'
    },
    url: {
      fr: 'https://www.oboncoin.fr/achat-immobilier-cryptomonnaie'
    },
    date: '2025-06-12',
    type: 'web',
    citation: {
      fr: 'D’autre part, le vendeur peut se sentir rassuré par le fait de recevoir le paiement en euros, ce qui annule le risque lié aux fluctuations du marché des cryptos.'
    }
  },
  {
    titre: {
      fr: 'Bien immobilier : une première transaction avec des cryptomonnaies a été réalisée en France'
    },
    source: {
      media: 'Zoom Invest',
      logo_url: '/press/zoominvest-favicon.ico'
    },
    url: {
      fr: 'https://zoominvest.fr/articles/view/05-06-25/bien-immobilier-une-premiere-transaction-avec-des-cryptomonnaies-a-ete-realisee-en-france'
    },
    date: '2025-06-05',
    type: 'web',
    citation: {
      fr: 'L’opération a été rendue possible via la solution « Legibloq » développée par JBDA (fruit d’un partenariat entre Jarvix et le cabinet Bruzzo Dubucq). Cette solution assure de l’innovation et de la sécurité pour les deux parties.'
    }
  },
  {
    titre: {
      fr: 'Immobilier : la première transaction en stablecoins réalisée à Lyon'
    },
    source: {
      media: 'cityramag.fr',
      logo_url: 'https://img.logo.dev/cityramag.fr?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://cityramag.fr/immobilier-la-premiere-transaction-en-stablecoins-realisee-a-lyon'
    },
    date: '2025-06-05',
    type: 'web',
    citation: {
      fr: 'Legibloq de JBDA est un dispositif de séquestre de cryptomonnaie. Il permet à tout acquéreur disposant de crypto-actifs de les utiliser directement pour l’achat d’un bien immobilier. Et ce sans passer par une banque ni par le vendeur, qui reçoit directement son argent en liquide avec la garantie d’une opération légalisée.'
    }
  },
  {
    titre: {
      fr: 'Actualité sur : Cryptomonnaie, Marchands de sommeil, Travaux, BNP Paribas Cardif'
    },
    source: {
      media: 'Expression',
      logo_url: '/press/magazineexpression-favicon.ico'
    },
    url: {
      fr: 'https://www.magazineexpression.fr/Actu/Actualit%C3%A9%20%2F%20Infos/actualite-sur-cryptomonnaie-marchands-de-sommeil-travaux-bnp-paribas-cardif-4159'
    },
    date: '2025-06-30',
    type: 'web',
    citation: {
      fr: 'Le 19 juin 2025 a marqué un tournant dans la vie de l’immobilier français : pour la première fois, une maison a été achetée à Lyon en cryptomonnaies, pour un montant de 370 000 euros.'
    }
  },
  {
    titre: {
      fr: ' Des cryptos en béton pour investir dans la pierre, mais finito MaPrimeRenov’ !'
    },
    source: {
      media: 'Idéal Investisseur',
      logo_url: 'https://img.logo.dev/ideal-investisseur.fr?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.ideal-investisseur.fr/briefing-du-jour/2025-06-05.html'
    },
    date: '2025-06-05',
    type: 'web',
    citation: {
      fr: 'Le système repose sur un séquestre sécurisé, un mécanisme de surcollatéralisation pour absorber la volatilité et une conformité stricte avec la réglementation LCB-FT et MiCA.'
    }
  },
  {
    titre: {
      fr: 'Immobilier : la première transaction française en cryptomonnaie réalisée à Lyon'
    },
    source: {
      media: 'immo2.pro',
      logo_url: 'https://img.logo.dev/immo2.pro?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://immo2.pro/actualite-immobilier/immobilier-la-premiere-transaction-francaise-en-cryptomonnaie-realisee-a-lyon'
    },
    date: '2025-07-08',
    type: 'web',
    citation: {
      fr: 'Simple et conforme au cadre juridique français et européen, elle permet à l’acheteur de se passer d’une banque. Et ce tout en respectant les obligations liées à la lutte contre le blanchiment et le financement du terrorisme.'
    }
  },
  {
    titre: {
      fr: 'Ma crypto ne vaut rien pour les banques ? Voici la solution qui a permis de contourner le système bancaire pour acheter une maison à 370 000 €'
    },
    source: {
      media: 'Koliving.fr',
      logo_url: 'https://img.logo.dev/koliving.fr?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.koliving.fr/ma-crypto-ne-vaut-rien-pour-les-banques-voici-la-solution-qui-a-permis-a-cet-investisseur-de-contourner-le-systeme-bancaire-pour-acheter-une-maison-a-370-000-e'
    },
    date: '2025-06-05',
    type: 'web',
    citation: {
      fr: 'Nous ne ‘contournons’ pas le système, nous en bâtissons un nouveau, plus agile et adapté au patrimoine du 21e siècle. Nous faisons le travail de traduction et de vérification que les banques refusent encore de faire », explique le fondateur d’un PSAN français.'
    }
  },
  {
    titre: {
      fr: 'Et si on achetait notre maison en crypto ?'
    },
    source: {
      media: 'Sophia Mag',
      logo_url: 'https://img.logo.dev/sophiamag.eu?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.sophiamag.eu/article/et-si-on-achetait-notre-maison-en-crypto.2025.1750971097_685db2d9e4ab6'
    },
    date: '2025-06-18',
    type: 'web',
    citation: {
      fr: 'Conçue pour être à la fois simple et conforme au cadre juridique français et européen, elle permet à tout acquéreur disposant de crypto-actifs de les utiliser directement pour acheter un bien immobilier, sans passer par une banque ni impacter le vendeur.'
    }
  },
  {
    titre: {
      fr: 'Une première en France : une transaction immobilière en cryptomonnaies, le vendeur perçoit des euros'
    },
    source: {
      media: 'worldinmaps.fr',
      logo_url: '/press/logo-worldinmaps.png'
    },
    url: {
      fr: 'https://worldinmaps.fr/une-premiere-en-france-une-transaction-immobiliere-en-cryptomonnaies-le-vendeur-percoit-des-euros'
    },
    date: '2025-06-06',
    type: 'web',
    citation: {
      fr: 'Non, il perçoit uniquement des euros grâce à la conversion opérée par JBDA, ce qui lui évite le risque lié à la volatilité.'
    }
  },
  {
    titre: {
      fr: 'France : le tout premier achat immobilier crypto a été réalisé !'
    },
    source: {
      media: 'Bitget News',
      logo_url: 'https://img.logo.dev/bitget.com?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.bitget.com/fr/news/detail/12560604797452'
    },
    date: '2025-06-05',
    type: 'web',
    citation: {
      fr: 'La première transaction immobilière crypto a été réalisée par Legibloq, une plateforme française innovante qui propose un service de séquestre crypto-asset certifié.'
    }
  },
  {
    titre: {
      fr: 'Achat immobilier en cryptomonnaie avec Legibloq, la solution fiable'
    },
    source: {
      media: 'Immo Basque',
      logo_url: '/press/logo-immobasque.webp'
    },
    url: {
      fr: 'https://immo-basque.com/blog-immobilier-biarritz/achat-immobilier-en-cryptomonnaie-avec-legibloq'
    },
    date: '2025-06-23',
    type: 'web',
    citation: {
      fr: 'En juin 2025, Legibloq a permis la première vente immobilière 100 % crypto sécurisée en France. Grâce à la surcollatéralisation et à l’ ...'
    }
  },
  {
    titre: {
      fr: 'Première Transaction Immobilière en Cryptomonnaie en France'
    },
    source: {
      media: 'Uni Immobilier',
      logo_url: 'https://img.logo.dev/uni-immobilier.fr?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://www.uni-immobilier.fr/transaction-immo-crypto'
    },
    date: '2025-06-05',
    type: 'web',
    citation: {
      fr: 'Elle démontre que les cryptomonnaies peuvent être intégrées de manière sécurisée et efficace dans des transactions immobilières, offrant ainsi une alternative ...'
    }
  },
  {
    titre: {
      fr: 'cryptomonnaies et euros s’unissent en France'
    },
    source: {
      media: 'L’investisseur Malin',
      logo_url: 'https://img.logo.dev/linvestisseur-malin.fr?token=pk_SXXHi3dGRzaPVDDasR804A&size=256'
    },
    url: {
      fr: 'https://linvestisseur-malin.fr/maison-cryptomonnaies-france'
    },
    date: '2025-06-05',
    type: 'web',
    citation: {
      fr: 'En 2025, JBDA se positionne comme un acteur majeur de l’intégration des cryptomonnaies dans l’immobilier français. Grâce à sa plateforme Legibloq, la société ...'
    }
  }
]



